module.exports = __webpack_public_path__ + "img/login_logo_hm.195e5d0b.png";